<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-chart-bar mr-1"></i> Relatório dos Alunos
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <!-- Period -->
                        <change-date :start-date="from" :end-date="to" locale="pt-BR" @changeDate="changeDate" class="ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0"></change-date>

                        <!-- Export -->
                        <div class="dropdown">
                            <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                <i class="fas fa-file-excel"></i>    
                                Exportar
                            </button>

                            <div class="dropdown-menu">
                                <a 
                                class="dropdown-item" 
                                :href="'/teacher/reports-students/export?group_id=' + (filter.group_id ? filter.group_id : '') + '&mode_id=' + (filter.mode_id ? filter.mode_id : '')+ '&start_date=' + this.$moment(this.filter.start_date).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.filter.end_date).format('YYYY-MM-DD')"
                                >
                                    Notas
                                </a>
                                <a 
                                class="dropdown-item" 
                                :href="'/teacher/reports-students/export-sendings?group_id=' + (filter.group_id ? filter.group_id : '') + '&mode_id=' + (filter.mode_id ? filter.mode_id : '')+ '&student_id=' + (filter.student_id ? filter.student_id : '')+ '&start_date=' + this.$moment(this.filter.start_date).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.filter.end_date).format('YYYY-MM-DD')">
                                    Envios
                                </a>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="container">

            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Turma">
                        <multiselect
                            v-model="group"
                            :options="groups"
                            :loading="loadingGroup"
                            track-by="id"
                            label="name"
                            @select="selectGroup"
                            @remove="removeGroup"
                            @search-change="searchGroup"
                            placeholder="Filtrar por Turma ..."
                            tag-placeholder="Filtrar Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Aluno">
                        <multiselect
                            v-model="student"
                            :options="students"
                            :loading="loadingStudent"
                            track-by="id"
                            label="name"
                            @select="selectStudent"
                            @remove="removeStudent"
                            @search-change="searchStudent"
                            placeholder="Filtrar por Aluno ..."
                            tag-placeholder="Filtrar Aluno"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há alunos disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Modo de Correção">
                        <multiselect
                            v-model="mode"
                            :options="modes"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Filtrar por Modo de Correção ..."
                            tag-placeholder="Filtrar Modo de Correção"
                            @select="selectMode"
                            @remove="removeMode"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há modos de correção disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <!-- Chart Overview -->
            <b-card class="mb-4">
                <b-overlay :show="loading" rounded="sm">
                        <chart-overview :chart-data="chartOverview"></chart-overview>
                </b-overlay>
            </b-card>

            <!-- Charts per Mode -->
            <b-card class="mb-4" v-for="chartMode in chartModes" :key="chartMode.id">

                <template #header>
                    <div class="h5 pt-2">{{ chartMode.name }}</div>
                    <div class="text-muted">
                        {{ chartMode.description | truncate(130) }}
                    </div>
                </template>

                <b-overlay :show="loading" rounded="sm">

                    <div class="row mb-3">
                        <div class="col-sm-6">
                            <div class="card">
                                <div class="card-body">
                                    <h2>
                                        {{ chartMode.overview.count }}
                                    </h2>
                                    <div class="font-weight-bold">
                                        Redações Corrigidas
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="card">
                                <div class="card-body">
                                    <h2>
                                        {{ chartMode.overview.average }}
                                    </h2>
                                    <div class="font-weight-bold">
                                        Média das Notas
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Note -->
                    <chart-count-essays :chart-data="chartMode.chartNotes"></chart-count-essays>

                    <!-- Field -->
                    <chart-field :chart-data="chartMode.chartFields"></chart-field>

                </b-overlay>
            </b-card>
        </div>
    </div>
</template>

<script>
import ChangeDate from "./Shared/ChangeDate";
import ChartCountEssays from "./ChartCountEssays";
import ChartField from "./ChartField";
import ChartOverview from './ChartOverview.vue';

export default {
    components: {
        ChangeDate,
        ChartCountEssays,
        ChartField,
        ChartOverview
    },
    props: ['from', 'to', 'modes'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingStudent: false,
            chartOverview: [],
            chartModes: [],
            filter: {
                start_date: this.from,
                end_date: this.to,
                group_id: null,
                student_id: null,
                mode_id: null,
            },
            group: null,
            groups: [],
            student: null,
            students: [],
            mode: null,
        }
    },
    created() {

        // Load
        this.load()

        // Load Groups
        this.searchGroup(null)

        // Load Students
        this.searchStudent(null)

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/reports/essays', {
                params: {
                    start_date: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                    end_date: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                    group_id: this.filter.group_id,
                    student_id: this.filter.student_id,
                    mode_id: this.filter.mode_id,
                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    
                    
                    this.chartOverview = response.chartOverview;
                    this.chartModes = response.chartModes;

                })
                .finally(() => this.loading = false)
        },

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                })
                .finally(() => this.loadingGroup = false)
        },

        searchStudent(text) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.filter.group_id,
                    name: text
                }
            })
                .then((result) => {
                    this.students = result.data.data.students;
                })
                .finally(() => this.loadingStudent = false)
        },

        async selectGroup(value) {
            this.filter.group_id = await value.id;
            this.filter.student_id = await null
            this.student = await null

            // Load Students
            await this.searchStudent(null)

            // Load
            await this.load()
        },

        async removeGroup() {
            this.filter.group_id = await null;
            this.filter.student_id = await null
            this.student = await null
            this.students = []

            // Load
            await this.load()
        },

        async selectStudent(value) {
            this.filter.student_id = await value.id;

            // Load
            await this.load()
        },

        async removeStudent() {
            this.filter.student_id = await null

            // Load
            await this.load()
        },

        async selectMode(value) {
            this.filter.mode_id = await value.id;

            // Load
            await this.load()
        },

        async removeMode() {
            this.filter.mode_id = await null

            // Load
            await this.load()
        },

        async changeDate(dateFilters) {
            this.filter.start_date = await dateFilters.startDate;
            this.filter.end_date = await dateFilters.endDate;

            // Load
            await this.load()
        },

    }
}
</script>

<style scoped>

</style>
